module.exports = __webpack_public_path__ + "static/media/drag.9503914f.svg";